import AssignmentIcon from '@material-ui/icons/Assignment';
import CodeIcon from '@material-ui/icons/Code';
import DashboardIcon from '@material-ui/icons/Dashboard';
import ExtensionIcon from '@material-ui/icons/Extension';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import LibraryBooksIcon from '@material-ui/icons/LibraryBooks';
import LinkIcon from '@material-ui/icons/Link';
import { normalizeFavoriteIconKey } from '../../homeFavorites';

const ICONS = {
  code: CodeIcon,
  assignment: AssignmentIcon,
  dashboard: DashboardIcon,
  extension: ExtensionIcon,
  helpOutline: HelpOutlineIcon,
  libraryBooks: LibraryBooksIcon,
  link: LinkIcon,
};

export const HomeFavoriteIcon = ({ icon }: { icon?: string }) => {
  const Icon = ICONS[normalizeFavoriteIconKey(icon)];
  return <Icon style={{ width: 20, height: 20 }} />;
};
